import { useState } from 'react';
import { Title } from '@nimbus-ds/components';
import { VirtualDataList } from 'commons/components';
import {
  useGetPartnerAdminAccessQuery,
  useGetRolesQuery,
} from 'domains/Configurations/Users/usersApi';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import {
  PartnersListMobileRow,
  PartnersListMobileSkeleton,
} from './components';
import { usePartnersListMobile } from '../../hooks';
import UnlinkPartnerModal from '../UnlinkPartnerModal';

function PartnersListMobile() {
  const {
    data: partners,
    ids,
    isLoading: isPartnersLoading,
    handleInfiniteScroll,
    handlePullToRefresh,
    showSpinner,
  } = usePartnersListMobile();
  const t = useTranslationConfigurations('partnersListComponent');
  const { data: storeRoles, isLoading: isRolesLoading } = useGetRolesQuery();
  const { data: partnerAdminAccess } = useGetPartnerAdminAccessQuery();
  const showSkeleton = isPartnersLoading || isRolesLoading;
  const [selectedPartnerToUnlink, setSelectedPartnerToUnlink] = useState<{
    partnerName: string;
    partnerEmail: string;
    isModalOpen: boolean;
    partnerId: number;
    permissionId: number;
  } | null>(null);

  const allRoles = { ...storeRoles?.roles, ...storeRoles?.appRoles };

  if (showSkeleton) return <PartnersListMobileSkeleton />;
  if (!partners || partners?.length === 0) return null;

  return (
    <>
      <Title as="h4">{t('title')}</Title>
      <VirtualDataList
        onRefresh={handlePullToRefresh}
        isPullable
        data={ids}
        endReached={handleInfiniteScroll}
        itemContent={(index) => (
          <PartnersListMobileRow
            key={`partners-list-item-mobile-${partners[index].id}-${index}`}
            partner={partners[index]}
            storeRoles={allRoles}
            hasPartnerAdminAccess={
              partnerAdminAccess &&
              partnerAdminAccess?.permissionsWithPartner?.length > 0
            }
            onUnlinkPartner={(unlinkPartner) =>
              setSelectedPartnerToUnlink({
                partnerName: unlinkPartner.partnerName,
                partnerEmail: unlinkPartner.partnerEmail,
                isModalOpen: true,
                partnerId: unlinkPartner.partnerId,
                permissionId: unlinkPartner.id,
              })
            }
          />
        )}
        showFooter={showSpinner}
      />
      <UnlinkPartnerModal
        isOpen={selectedPartnerToUnlink?.isModalOpen ?? false}
        onClose={() =>
          setSelectedPartnerToUnlink({
            partnerId: 0,
            permissionId: 0,
            partnerName: '',
            partnerEmail: '',
            isModalOpen: false,
          })
        }
        partnerName={selectedPartnerToUnlink?.partnerName || ''}
        partnerEmail={selectedPartnerToUnlink?.partnerEmail || ''}
        partnerId={selectedPartnerToUnlink?.partnerId ?? 0}
        permissionId={selectedPartnerToUnlink?.permissionId ?? 0}
      />
    </>
  );
}

export default PartnersListMobile;
